import { useInfiniteQuery } from 'react-query';
import { ItemServiceListRequest } from './ItemService.types';
import ItemServiceServices from './ItemService.services';
import notificationError from '@/utils/functions/notificationError';

export function useItemServiceList(params: ItemServiceListRequest) {
  return useInfiniteQuery(
    ['item-services', { ...params }],
    ({ pageParam: nextToken }) => {
      const req: ItemServiceListRequest = {
        rows: 10,
        ...params,
        order: params.order || 0,
        nextToken,
      };

      return ItemServiceServices.list(req);
    },
    {
      enabled: !!params.modelId,
      getNextPageParam: (lastPage) => lastPage.nextToken,
      onError(err) {
        notificationError(err);
      },
    },
  );
}
